var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.portfolioLinker.opened
        ? _c("div", { staticClass: "modal-mask" }, [
            _c("div", { staticClass: "modal-wrapper" }, [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Link portfolio"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.closePortfolioLinker },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Workspace:")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.portfolioLinker.workspaceId,
                              expression: "portfolioLinker.workspaceId",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.portfolioLinker,
                                "workspaceId",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.rm.Workspaces, function (w) {
                          return _c(
                            "option",
                            { domProps: { value: w.WorkspaceId } },
                            [_vm._v(_vm._s(w.Name))]
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.tchProjects != null
                      ? _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Portfolio:")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.portfolioLinker.tchProjectId,
                                  expression: "portfolioLinker.tchProjectId",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.portfolioLinker,
                                    "tchProjectId",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.tchProjects, function (p) {
                              return _c(
                                "option",
                                { domProps: { value: p.Id } },
                                [_vm._v(_vm._s(p.Name))]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          enabled: _vm.portfolioLinker.canSave,
                        },
                        on: { click: _vm.handleLinkPortfolioCommand },
                      },
                      [_vm._v("Link")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.closePortfolioLinker },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("PortfolioCreatorDialog", {
        attrs: { viewModel: _vm.portfolioCreatorDialog },
        on: { "create-portfolio": _vm.handleCreatePortfolioCommand },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "portfolios" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          staticStyle: { padding: "0.7em 2em" },
                          attrs: { role: "button" },
                          on: { click: _vm.showPortfolioCreator },
                        },
                        [_vm._v("Create portfolio")]
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu dropdown-menu-right" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: { click: _vm.showPortfolioLinker },
                            },
                            [_vm._v("Link existing portfolio")]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.validPortfolios, function (p) {
                          return _c("tr", { key: p.Id }, [
                            _c("td", [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/alternatives/kanban/${p.WorkspaceId}/${p.TchProjectId}`,
                                      expression:
                                        "`/#/alternatives/kanban/${p.WorkspaceId}/${p.TchProjectId}`",
                                    },
                                  ],
                                },
                                [_vm._v(_vm._s(p.Name))]
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v("Workspace: " + _vm._s(p.WorkspaceName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "dropdown" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary dropdown-toggle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Actions\n                                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value: `/#/portfolio/settings/${_vm.workspaceId}/${p.TchProjectId}`,
                                            expression:
                                              "`/#/portfolio/settings/${workspaceId}/${p.TchProjectId}`",
                                          },
                                        ],
                                        staticClass: "dropdown-item",
                                      },
                                      [_vm._v("Settings")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDeletePortfolioCommand(
                                              p
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Delete")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ])
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.invalidPortfolios, function (p) {
                          return _c(
                            "tr",
                            { key: p.Id, staticClass: "table-danger" },
                            [
                              _c("td", [_vm._v(_vm._s(p.Name))]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDeletePortfolioCommand(
                                          p
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Delete\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Portfolios")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass:
          "btn btn-outline-success dropdown-toggle dropdown-toggle-split",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Portfolio")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }